import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { isEmpty, startCase } from 'lodash';

class SearchField extends Component {
  render() {
    const {
      handleInputChange,
      searchOption,
      searchFields,
      value,
      multipleSearches,
      changed,
      noPlaceholder,
    } = this.props;
    const searchValue = isEmpty(value)
      && searchFields
      && !(multipleSearches && changed[searchOption])
      ? searchFields[searchOption]
      : value;

    return (
      <Form.Field>
        <Form.Input
          name={searchOption}
          data-testid={`${searchOption}-input`}
          placeholder={
            !noPlaceholder ? 'Search by ' + startCase(searchOption) : ''
          }
          value={searchValue || ''}
          onChange={handleInputChange}
        />
      </Form.Field>
    );
  }
}

SearchField.propTypes = {
  handleInputChange: PropTypes.func,
  searchOption: PropTypes.string,
  searchFields: PropTypes.object,
  value: PropTypes.string,
  multipleSearches: PropTypes.bool,
  changed: PropTypes.object,
  noPlaceholder: PropTypes.bool,
};

export default SearchField;
